import { FullWidthSpace } from "melco-ui";
import { useColorCollectionReferences } from "../../../hooks/libraries/colorCollections/useColorCollectionReferences";
import { useTranslation } from "react-i18next";
import { ReferencesListAlert } from "../../references/ReferencesListAlert";
import { InputFormatReferencesList } from "../../references/InputFormatReferencesList";
import { DataMappingReferencesList } from "../../references/DataMappingReferencesList";

type ColorCollectionReferencesListProps = {
  colorCollectionId: string;
};

export const ColorCollectionReferencesList: React.FC<
  ColorCollectionReferencesListProps
> = ({ colorCollectionId }) => {
  const { t } = useTranslation();

  const { data: colorCollectionReferences } =
    useColorCollectionReferences(colorCollectionId);

  return (
    <FullWidthSpace direction="vertical" size="large">
      <ReferencesListAlert
        message={t("color_collections.actions.references.warning")}
      />

      <DataMappingReferencesList
        dataMappingList={
          colorCollectionReferences?.global_mapping_list ?? undefined
        }
      />

      <InputFormatReferencesList
        inputFormatMappingList={
          colorCollectionReferences?.format_list ?? undefined
        }
      />
    </FullWidthSpace>
  );
};
